import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { IndexloginService } from '../indexlogin/indexlogin.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: IndexloginService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {

    const isLoggedIn = this.authService.isLoggedIn();

    if (!isLoggedIn) {
      const urlSegments = state.url.split('/');
      const subdomain = urlSegments[1] || localStorage.getItem('waldo_sub_domain') || 'waldoerp';
      return this.router.createUrlTree([`${subdomain}/login`]);
    }

    return true;
  }
}


